export default __webpack_public_path__ + "static/media/github.8d843d2b.svg";